import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBalanceScale,
  faBriefcaseMedical,
  faChartBar,
  faHandshake,
  faShoppingCart,
  faUser,
  faBook,
  faCog,
  faQuestionCircle,
  faHome,
  faMoneyBill,
} from "@fortawesome/free-solid-svg-icons";

const useStyles = makeStyles(() => ({
  fontIcons: {
    fontSize: "14px",
  },
}));

// ✅ Safe JSON parse
const safeParse = (item) => {
  try {
    return JSON.parse(item);
  } catch (e) {
    return null;
  }
};

// ✅ Helper to always return a safe object with default values
const safePermission = (perm) =>
  perm && typeof perm === "object"
    ? perm
    : { create: false, read: false, update: false, delete: false };

export const useMainPageModules = () => {
  const classes = useStyles();

  // ✅ Guard against null sessionStorage
  const user = safeParse(sessionStorage.getItem("user")) || {};
  const permissions = user?.permission || {};

  console.log("permissions ", permissions);
  console.log("user ", user);

  // ✅ Always wrap with safePermission
  const dashboard = safePermission(permissions.dashboard);
  const credit_sales = safePermission(permissions.credit_sales);
  const manage_sales = safePermission(permissions.manage_sales);
  const cash_sales = safePermission(permissions.cash_sales);
  const gui_pos = safePermission(permissions.gui_pos);

  const add_customer = safePermission(permissions.add_customer);
  const manage_customer = safePermission(permissions.manage_customer);
  const credit_customer = safePermission(permissions.credit_customer);
  const paid_customer = safePermission(permissions.paid_customer);

  const add_category = safePermission(permissions.add_category);
  const medicine_type = safePermission(permissions.medicine_type);
  const add_medicine = safePermission(permissions.add_medicine);
  const import_medicine_csv = safePermission(permissions.import_medicine_csv);
  const manage_medicine = safePermission(permissions.manage_medicine);
  const add_unit = safePermission(permissions.add_unit);
  const unit_list = safePermission(permissions.unit_list);

  const add_supplier = safePermission(permissions.add_supplier);
  const manage_supplier = safePermission(permissions.manage_supplier);
  const supplier_ledger = safePermission(permissions.supplier_ledger);
  const supplier_sales_details = safePermission(
    permissions.supplier_sales_details
  );

  const add_purchase = safePermission(permissions.add_purchase);
  const manage_purchase = safePermission(permissions.manage_purchase);
  const add_lpo = safePermission(permissions.add_lpo);
  const edit_lpo = safePermission(permissions.edit_lpo);
  const approve_lpo = safePermission(permissions.approve_lpo);
  const cancel_lpo = safePermission(permissions.cancel_lpo);

  const stock_report = safePermission(permissions.stock_report);
  const stock_report_batch_wise = safePermission(
    permissions.stock_report_batch_wise
  );

  const todays_report = safePermission(permissions.todays_report);
  const sales_report = safePermission(permissions.sales_report);
  const purchase_report = safePermission(permissions.purchase_report);
  const sales_report_medicine_report = safePermission(
    permissions.sales_report_medicine_wise
  );
  const profit_loss = safePermission(permissions.profit_loss);

  const invoice_return = safePermission(permissions.return);
  const stock_return_list = safePermission(permissions.stock_return_list);

  const add_user = safePermission(permissions.add_user);
  const manage_users = safePermission(permissions.manage_users);
  const add_role = safePermission(permissions.add_role);
  const role_list = safePermission(permissions.role_list);
  const user_assign_role = safePermission(permissions.user_assign_role);

  const chart_of_accounts = safePermission(permissions.chart_of_accounts);
  const journals = safePermission(permissions.journals);
  const expenses = safePermission(permissions.expenses);
  const debit = safePermission(permissions.debit);

  const customer_cash_sale = safePermission(permissions.customer_cash_sale);
  const business_cash_sale = safePermission(permissions.business_cash_sale);
  const customer_credit_sale = safePermission(permissions.customer_credit_sale);
  const business_credit_sale = safePermission(permissions.business_credit_sale);
  const approval_status = safePermission(permissions.approval_status);
  const managependingsale = safePermission(permissions.managependingsale);

    // console.log("permissions ",permissions);
  // const credit = permissions.credit ? permissions.credit : {};

  const arr = [
    {
      module_name: "Dashboard",
      icon: <FontAwesomeIcon className={classes.fontIcons} icon={faHome} />,
      link: "/",
      modules: [],
      isVisible:  dashboard.read,
    },

    {
      module_name: "Sales",
      icon: (
        <FontAwesomeIcon className={classes.fontIcons} icon={faBalanceScale} />
      ),
      modules: [
      //   {
      //     text: "Customer Cash Sale",
      //     route: "/new-receipt",
      //     isVisible:
      //       cash_sales.create ||
      //       cash_sales.read ||
      //       cash_sales.update ||
      //       cash_sales.delete,
      //   },
      //   {
      //     text: "Customer Credit Sale",
      //     route: "/createinvoice/new-invoice",
      //     isVisible:
      //       credit_sales.create ||
      //       credit_sales.read ||
      //       credit_sales.update ||
      //       credit_sales.delete,
      //   },

      //   {
      //     text: "Business Cash Sale",
      //     route: "/WholeSale-receipt",
      //     isVisible:
      //       cash_sales.create ||
      //       cash_sales.read ||
      //       cash_sales.update ||
      //       cash_sales.delete,
      //   },
      //   {
      //     text: "Business Credit Sale",
      //     route: "/create-WholeSale-invoice/WholeSaleInvoice",
      //     isVisible:
      //       credit_sales.create ||
      //       credit_sales.read ||
      //       credit_sales.update ||
      //       credit_sales.delete,
      //   },
        {
          text: "Receive  payments",
          route: "/managependingsale",
          isVisible:
          managependingsale.create ||
          managependingsale.read ||
          managependingsale.update ||
          managependingsale.delete,
        },
        {
          text: "Manage Sales",
          route: "/sales-receipts",
          isVisible:
            manage_sales.create ||
            manage_sales.read ||
            manage_sales.update ||
            manage_sales.delete,
        },
      ],
      isVisible:
        (managependingsale || manage_sales) &&
        (managependingsale.create ||
          managependingsale.read ||
          managependingsale.update ||
          managependingsale.delete ||
          manage_sales.create ||
          manage_sales.read ||
          manage_sales.update ||
          manage_sales.delete ||
          gui_pos.create ||
          gui_pos.read ||
          gui_pos.update ||
          gui_pos.delete),
    },

    {
      module_name: "Dispenser",
      icon: (
        <FontAwesomeIcon className={classes.fontIcons} icon={faBalanceScale} />
      ),
      modules: [
        {
          text: "Client Cash Sale",
          route: "/dispenser/retail",
          isVisible:
          customer_cash_sale.create ||
          customer_cash_sale.read ||
          customer_cash_sale.update ||
          customer_cash_sale.delete,
        },
        // {
        //   text: "Facility Cash Sale",
        //   route: "/dispenser/wholesale",
        //   isVisible:
        //   business_cash_sale.create ||
        //   business_cash_sale.read ||
        //     business_cash_sale.update ||
        //     business_cash_sale.delete,
        // },

        // {
        //   text: "Client Credit Sale",
        //   route: "/dispensarInvoice/retail",
        //   isVisible:
        //   customer_credit_sale.create ||
        //   customer_credit_sale.read ||
        //   customer_credit_sale.update ||
        //     customer_credit_sale.delete,
        // },
        // {
        //   text: "Facility Credit Sale",
        //   route: "/dispensarInvoice/wholesale",
        //   isVisible:
        //   business_credit_sale.create ||
        //   business_credit_sale.read ||
        //   business_credit_sale.update ||
        //   business_credit_sale.delete,
        // },
        {
          text: "Approval Status",
          route: "/pendingapproval",
          isVisible:
          approval_status.create ||
          approval_status.read ||
          approval_status.update ||
          approval_status.delete,
        },
      ],
      isVisible:
        (customer_cash_sale || business_cash_sale ||customer_credit_sale|| business_credit_sale||approval_status) ||
        (business_cash_sale.create ||
          business_cash_sale.read ||
          business_cash_sale.update ||
          business_cash_sale.delete ||
          customer_credit_sale.create  ||
          customer_credit_sale.read ||
          customer_credit_sale.update ||
          customer_credit_sale.delete ||
          business_credit_sale.create  ||
          business_credit_sale.read ||
          business_credit_sale.update ||
          business_credit_sale.delete ||
          approval_status.create ||
          approval_status.read ||
          approval_status.update ||
          approval_status.delete ||
          customer_cash_sale.create ||
          customer_cash_sale.read ||
          customer_cash_sale.update ||
          customer_cash_sale.delete ||
          gui_pos.create ||
          gui_pos.read ||
          gui_pos.update ||
          gui_pos.delete),
    },

    {
      module_name: "Customer",
      icon: (
        <FontAwesomeIcon className={classes.fontIcons} icon={faHandshake} />
      ),
      modules: [
        {
          text: "Add Customer",
          route: "/addcustomer",
          isVisible:
            add_customer.create ||
            add_customer.read ||
            add_customer.update ||
            add_customer.delete,
        },

        {
          text: "Customers",
          route: "/managecustomer/manage_customer",
          isVisible:
            manage_customer.create ||
            manage_customer.read ||
            manage_customer.update ||
            manage_customer.delete ||
            add_customer.create ||
            add_customer.read ||
            add_customer.update ||
            add_customer.delete,
        },
        {
          text: "Deactivated Customers",
          route: "/managecustomer/deactivated_customers",
          isVisible:
            manage_customer.create ||
            manage_customer.read ||
            manage_customer.update ||
            manage_customer.delete,
        },
        {
          text: "Accounts Receivable",
          route: "/accounting/debtors/customer",
          isVisible:
            manage_customer.create ||
            manage_customer.read ||
            manage_customer.update ||
            manage_customer.delete ||
            add_customer.create ||
            add_customer.read ||
            add_customer.update ||
            add_customer.delete,
        },
      ],
      isVisible:
        (permissions.add_customer ||
          permissions.manage_customer ||
          permissions.paid_customer ||
          permissions.credit_customer) &&
        (add_customer.create ||
          add_customer.read ||
          add_customer.update ||
          add_customer.delete ||
          manage_customer.create ||
          manage_customer.read ||
          manage_customer.update ||
          manage_customer.delete ||
          credit_customer.create ||
          credit_customer.read ||
          credit_customer.update ||
          credit_customer.delete ||
          paid_customer.create ||
          paid_customer.read ||
          paid_customer.update ||
          paid_customer.delete),
    },

    {
      module_name: "Product",
      icon: (
        <FontAwesomeIcon
          className={classes.fontIcons}
          icon={faBriefcaseMedical}
        />
      ),
      modules: [
        {
          text: "Add Product",
          route: "/addmedicine",
          isVisible:
            add_medicine.create ||
            add_medicine.read ||
            add_medicine.update ||
            add_medicine.delete,
        },
        {
          text: "Manage Product",
          route: "/managemedicine",
          isVisible:
            manage_medicine.create ||
            manage_medicine.read ||
            manage_medicine.update ||
            manage_medicine.delete,
        },
        {
          text: "Product Type",
          route: "/medicinetype",
          isVisible:
            medicine_type.create ||
            medicine_type.read ||
            medicine_type.update ||
            medicine_type.delete,
        },
        {
          text: "Unit",
          route: "/addunit",
          isVisible:
            add_unit.create ||
            add_unit.read ||
            add_unit.update ||
            add_unit.delete,
        },
        {
          text: "Category",
          route: "/managecategory",
          isVisible:
            add_category.create ||
            add_category.read !== 0 ||
            add_category.update ||
            add_category.delete,
        },
      ],
      isVisible:
        (permissions.add_category ||
          permissions.medicine_type ||
          permissions.add_medicine ||
          permissions.import_medicine_csv ||
          permissions.manage_medicine ||
          permissions.add_unit ||
          permissions.unit_list) &&
        (add_category.create ||
          add_category.read !== 0 ||
          add_category.update ||
          add_category.delete ||
          medicine_type.create ||
          medicine_type.read ||
          medicine_type.update ||
          medicine_type.delete ||
          add_unit.create ||
          add_unit.read ||
          add_unit.update ||
          add_unit.delete ||
          unit_list.create ||
          unit_list.read ||
          unit_list.update ||
          unit_list.delete ||
          add_medicine.create ||
          add_medicine.read ||
          add_medicine.update ||
          add_medicine.delete ||
          import_medicine_csv.create ||
          import_medicine_csv.read ||
          import_medicine_csv.update ||
          import_medicine_csv.delete ||
          manage_medicine.create ||
          manage_medicine.read ||
          manage_medicine.update ||
          manage_medicine.delete),
    },

    {
      module_name: "Purchase",
      icon: (
        <FontAwesomeIcon className={classes.fontIcons} icon={faShoppingCart} />
      ),
      modules: [
        {
          text: "Add Purchase",
          route: "/addpurchase",
          isVisible:
            manage_purchase.create 
        },
        {
          text: "Purchases",
          route: "/managepurchase",
          isVisible:
            manage_purchase.create ||
            manage_purchase.read ||
            manage_purchase.update ||
            manage_purchase.delete,
        },
        {
          text: "Purchase Orders",
          route: "/managepurchaseorder",
          isVisible:
            add_lpo.create ||
            add_lpo.read ||
            add_lpo.update ||
            add_lpo.delete ||
            edit_lpo.create ||
            edit_lpo.read ||
            edit_lpo.update ||
            edit_lpo.delete ||
            approve_lpo.create ||
            approve_lpo.read ||
            approve_lpo.update ||
            approve_lpo.delete ||
            cancel_lpo.create ||
            cancel_lpo.read ||
            cancel_lpo.update ||
            cancel_lpo.delete,
        },
      ],
      isVisible:
        (permissions.add_purchase ||
          permissions.manage_purchase ||
          add_lpo ||
          edit_lpo ||
          approve_lpo ||
          cancel_lpo) &&
        (add_purchase.create ||
          add_purchase.read ||
          add_purchase.update ||
          add_purchase.delete ||
          manage_purchase.create ||
          manage_purchase.read ||
          manage_purchase.update ||
          manage_purchase.delete ||
          add_lpo.create ||
          add_lpo.read ||
          add_lpo.update ||
          add_lpo.delete ||
          edit_lpo.create ||
          edit_lpo.read ||
          edit_lpo.update ||
          edit_lpo.delete ||
          approve_lpo.create ||
          approve_lpo.read ||
          approve_lpo.update ||
          approve_lpo.delete ||
          cancel_lpo.create ||
          cancel_lpo.read ||
          cancel_lpo.update ||
          cancel_lpo.delete),
    },

    {
      module_name: "Stock",
      icon: <FontAwesomeIcon className={classes.fontIcons} icon={faChartBar} />,
      modules: [
        {
          text: "Stock Report",
          route: "/stockreport",
          isVisible:
            stock_report.create ||
            stock_report.read ||
            stock_report.update ||
            stock_report.delete ||
            stock_report_batch_wise.create ||
            stock_report_batch_wise.read ||
            stock_report_batch_wise.update ||
            stock_report_batch_wise.delete,
        },
        {
          text: "Stock Adjustment",
          route: "/stockadjustment",
          isVisible:
            stock_report.create ||
            stock_report.read ||
            stock_report.update ||
            stock_report.delete,
        },
        {
          text: "Stock Adjustment List",
          route: "/stock-adjustment-list",
          isVisible:
            stock_report.create ||
            stock_report.read ||
            stock_report.update ||
            stock_report.delete,
        },
        {
          text: "Inconsistence Batches",
          route: "/inconsistence-batches",
          isVisible:
            stock_report.create ||
            stock_report.read ||
            stock_report.update ||
            stock_report.delete,
        },
      ],
      isVisible:
        (permissions.stock_report || permissions.stock_report_batch_wise) &&
        (stock_report.create ||
          stock_report.read ||
          stock_report.update ||
          stock_report.delete ||
          stock_report_batch_wise.create ||
          stock_report_batch_wise.read ||
          stock_report_batch_wise.update ||
          stock_report_batch_wise.delete),
    },

    // {module_name:'Refund',  icon:<FontAwesomeIcon className={classes.fontIcons} icon={faRetweet}/>,
    //     modules:[
    //         {text:'Refund Customer', route:'/return', isVisible:(
    //                 (invoice_return.create || invoice_return.read || invoice_return.update || invoice_return.delete)
    //             )},
    //         {text:'Refund List', route:'/stockreturnlist', isVisible:(
    //                 stock_return_list.create || stock_return_list.read || stock_return_list.update
    //                 || stock_return_list.delete
    //             )},
    //     ],
    //     isVisible:(
    //         (permissions.return || permissions.stock_return_list || permissions.manufacturer_return_list ||
    //             permissions.wastage_return_list)
    //     )},

    {
      module_name: "Supplier",
      icon: <FontAwesomeIcon className={classes.fontIcons} icon={faUser} />,
      modules: [
        {
          text: "Add Supplier",
          route: "/addmanufacturer",
          isVisible:
            add_supplier.create ||
            add_supplier.read ||
            add_supplier.update ||
            add_supplier.delete,
        },
        {
          text: "Manage Supplier",
          route: "/managemanufacturer",
          isVisible:
            manage_supplier.create ||
            manage_supplier.read ||
            manage_supplier.update ||
            manage_supplier.delete,
        },
        {
          text: "Accounts Payable",
          route: "/creditors/supplier",
          isVisible:
            manage_customer.create ||
            manage_customer.read ||
            manage_customer.update ||
            manage_customer.delete ||
            add_customer.create ||
            add_customer.read ||
            add_customer.update ||
            add_customer.delete,
        },
        // {text:'Supplier Sales Details', route:'/suppliersales', isVisible:(
        //         supplier_sales_details.create || supplier_sales_details.read ||
        //         supplier_sales_details.update || supplier_sales_details.delete
        //     )},
      ],
      isVisible:
        (permissions.add_supplier ||
          permissions.manage_supplier ||
          permissions.supplier_ledger ||
          permissions.supplier_sales_details) &&
        (add_supplier.create ||
          add_supplier.read ||
          add_supplier.update ||
          add_supplier.delete ||
          manage_supplier.create ||
          manage_supplier.read ||
          manage_supplier.update ||
          manage_supplier.delete ||
          supplier_ledger.create ||
          supplier_ledger.read ||
          supplier_ledger.update ||
          supplier_ledger.delete ||
          supplier_sales_details.create ||
          supplier_sales_details.read ||
          supplier_sales_details.update ||
          supplier_sales_details.delete),
    },

    {
      module_name: "Accounting",
      icon: (
        <FontAwesomeIcon className={classes.fontIcons} icon={faMoneyBill} />
      ),
      modules: [
        {
          text: "Chart of accounts",
          route: "/accounting/coa",
          isVisible:
            chart_of_accounts.create ||
            chart_of_accounts.read ||
            chart_of_accounts.update ||
            chart_of_accounts.delete,
        },
        // {text:'Setup Accounts', route:'/accounting/setup', isVisible:(
        //         chart_of_accounts.create || chart_of_accounts.read ||
        //         chart_of_accounts.update || chart_of_accounts.delete
        //     )},
        {
          text: "General Ledger",
          route: "/accounting/generalledger",
          isVisible:
            journals.create ||
            journals.read ||
            journals.update ||
            journals.delete,
        },
        {
          text: "Journals",
          route: "/accounting/journals",
          isVisible:
            journals.create ||
            journals.read ||
            journals.update ||
            journals.delete,
        },
         {
          text: "Expenses",
          route: "/accounting/expenses/active",
          isVisible:
            expenses.create ||
            expenses.read ||
            expenses.update ||
            expenses.delete,
        },
        {
          text: "Fixed Assets",
          route: "/accounting/fixed_assets/list",
          isVisible:
            chart_of_accounts.create ||
            chart_of_accounts.read ||
            chart_of_accounts.update ||
            chart_of_accounts.delete,
        },
        {
          text: "Payment Vouchers",
          route: "/accounting/payment_vouchers",
          isVisible:
            expenses.create ||
            expenses.read ||
            expenses.update ||
            expenses.delete,
        },
        // {
        //   text: "Debit Notes",
        //   route: "/accounting/managedebitnotes",
        //   // isVisible: debit.create || debit.read || debit.update || debit.delete,
        //   isVisible: true,
        // },
        // {
        //   // isVisible: debit.create || debit.read || debit.update || debit.delete,
        //   text: "Credit Notes",
        //   route: "/accounting/managecreditnotes",
        //   isVisible: true,
        // },
      ],
      isVisible:
        chart_of_accounts.create ||
        chart_of_accounts.read ||
        chart_of_accounts.update ||
        chart_of_accounts.delete ||
        chart_of_accounts.create ||
        chart_of_accounts.read ||
        chart_of_accounts.update ||
        chart_of_accounts.delete ||
        journals.create ||
        journals.read ||
        journals.update ||
        journals.delete ||
        expenses.create ||
        expenses.read ||
        expenses.update ||
        expenses.delete ||
        debit.create ||
        debit.read ||
        debit.update ||
        debit.delete,
    },

    {
      module_name: "Reports",
      icon: <FontAwesomeIcon className={classes.fontIcons} icon={faBook} />,
      link: "/allreports",
      modules: [],
      isVisible:
        (permissions.todays_report ||
          permissions.sales_report ||
          permissions.purchase_report ||
          permissions.sales_report_medicine_wise ||
          permissions.profit_loss) &&
        (todays_report.create ||
          todays_report.read ||
          todays_report.update ||
          todays_report.delete ||
          sales_report.create ||
          sales_report.read ||
          sales_report.update ||
          sales_report.delete ||
          purchase_report.create ||
          purchase_report.read ||
          purchase_report.update ||
          purchase_report.delete ||
          sales_report_medicine_report.create ||
          sales_report_medicine_report.read ||
          sales_report_medicine_report.update ||
          sales_report_medicine_report.delete ||
          profit_loss.create ||
          profit_loss.read ||
          profit_loss.update ||
          profit_loss.delete),
    },

    {
      module_name: "Settings",
      icon: <FontAwesomeIcon className={classes.fontIcons} icon={faCog} />,
      modules: [
        {
          text: "Manage Users",
          route: "/manageusers",
          isVisible:
            manage_users.create ||
            manage_users.read ||
            manage_users.update ||
            manage_users.delete ||
            add_user.create ||
            add_user.read ||
            add_user.update ||
            add_user.delete,
        },
        {
          text: "Roles",
          route: "/rolelist",
          isVisible:
            role_list.create ||
            role_list.read ||
            role_list.update ||
            role_list.delete ||
            add_role.create ||
            add_role.read ||
            add_role.update ||
            add_role.delete,
        },
        {
          text: "Assign User Role",
          route: "/assignuserrole",
          isVisible:
            user_assign_role.create ||
            user_assign_role.read ||
            user_assign_role.update ||
            user_assign_role.delete,
        },
        {
          text: "Setup Payment Methods",
          route: "/paymentmethods",
          isVisible:
            user_assign_role.create ||
            user_assign_role.read ||
            user_assign_role.update ||
            user_assign_role.delete,
        },
        {
          text: "Company Details",
          route: "/companydetails",
          isVisible:
            user_assign_role.create ||
            user_assign_role.read ||
            user_assign_role.update ||
            user_assign_role.delete,
        },
        {
          text: "Manual Backup",
          route: "/manualbackup",
          isVisible:
            user_assign_role.create ||
            user_assign_role.read ||
            user_assign_role.update ||
            user_assign_role.delete,
        },
        {
          text: "Support",
          route: "/support",
          isVisible: true,
          icon: (
            <FontAwesomeIcon
              className={classes.fontIcons}
              icon={faQuestionCircle}
            />
          ),
        },
      ],
      isVisible: true,
    },
  ];

  return { arr };
};
